const theme_color='#5c1d81'
export {theme_color}